import Vue from 'vue';
import Vuetify from 'vuetify/lib';
import { VTextField } from 'vuetify/lib';
import hr from 'vuetify/lib/locale/hr';

Vue.use(Vuetify, { components: { VTextField } });

Vue.component('my-component', {
	methods: {
		changeLocale() {
			this.$vuetify.lang.current = 'hr';
		},
	},
});

export default new Vuetify({
	icons: {
		iconfont: 'fa',
	},
	lang: {
		locales: { hr },
		current: 'hr',
	},
	theme: {
		themes: {
			light: {
				primary: '#009ec0',
				secondary: '#424242',
				success: '#4CAF50',
				warning: '#FFC107',
				basicButton: '#F5F5F5',
				appBar: '#EFEFEF',
				modalText: '#616161',
				icon: '#fff',
				calendar: '#eee',
				ratingStars: '#14426c',
				shade: '#f0f1f2',
				totalBruto: '#24186a',
				upload: '#5c5c5c',
			},
			dark: {
				primary: '#2196F3',
				secondary: '#525252',
				success: '#4CAF50',
				warning: '#FFC107',
				basicButton: '#444',
				appBar: '#363636',
				modalText: '#F5F5F5',
				icon: '#757575',
				calendar: '#757575',
				ratingStars: '#00a4e1',
				shade: '#272625',
				totalBruto: '#402abb',
			},
		},
		options: {
			customProperties: true,
		},
	},
});
